import { render, staticRenderFns } from "./RedirectionPageOTP.vue?vue&type=template&id=008c8040&"
import script from "./RedirectionPageOTP.vue?vue&type=script&lang=js&"
export * from "./RedirectionPageOTP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('008c8040')) {
      api.createRecord('008c8040', component.options)
    } else {
      api.reload('008c8040', component.options)
    }
    module.hot.accept("./RedirectionPageOTP.vue?vue&type=template&id=008c8040&", function () {
      api.rerender('008c8040', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/user/RedirectionPageOTP.vue"
export default component.exports